import { jsx, jsxs } from "react/jsx-runtime";
import React__default, { useCallback } from "react";
import { DirectionEnum } from "@perxis-auto/shared";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
import "antd/es/config-provider";
import "style-inject";
import { useProviderContext } from "../Provider/context.js";
function pairArray(array) {
  const pairs = [];
  array.forEach((item, i) => {
    if (i % 2 === 0) {
      const pair = [item, array[i + 1]].filter(Boolean);
      pairs.push(pair);
    }
  });
  return pairs;
}
const DealerInfoSchedule = ({
  items,
  className,
  onPhoneClick,
  onEmailClick,
  renderCell = (_, element) => element
}) => {
  const { direction } = useProviderContext();
  const isRTL = direction === DirectionEnum.Rtl;
  const pairItems = pairArray(items);
  const handlePhoneClick = useCallback(
    (e) => {
      var _a, _b;
      const phone = (_b = (_a = e == null ? void 0 : e.currentTarget) == null ? void 0 : _a.dataset) == null ? void 0 : _b.phone;
      if (phone) {
        onPhoneClick == null ? void 0 : onPhoneClick(phone);
      }
    },
    [onPhoneClick]
  );
  const handleEmailClick = useCallback(
    (e) => {
      var _a, _b;
      const email = (_b = (_a = e == null ? void 0 : e.currentTarget) == null ? void 0 : _a.dataset) == null ? void 0 : _b.email;
      if (email) {
        onEmailClick == null ? void 0 : onEmailClick(email);
      }
    },
    [onEmailClick]
  );
  const renderContactsCell = (item) => {
    var _a, _b, _c, _d;
    if (!((_a = item.phones) == null ? void 0 : _a.length) && !((_b = item.emails) == null ? void 0 : _b.length)) {
      return /* @__PURE__ */ jsx("td", {});
    }
    return /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: [
      !!((_c = item.phones) == null ? void 0 : _c.length) && renderCell(
        { item, type: "phones" },
        /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: item.phones.map((phone, i) => /* @__PURE__ */ jsx(
          Typography.Link,
          {
            href: `tel:${phone}`,
            level: "small",
            color: "darkest",
            "data-phone": phone,
            onClick: handlePhoneClick,
            className: classnames("perxis-auto-dealer-info-schedule__phone"),
            children: phone
          },
          i
        )) })
      ),
      !!((_d = item.emails) == null ? void 0 : _d.length) && renderCell(
        { item, type: "emails" },
        /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: item.emails.map((email, i) => /* @__PURE__ */ jsx(
          Typography.Link,
          {
            href: `mailto:${email}`,
            level: "small",
            color: "darkest",
            "data-email": email,
            onClick: handleEmailClick,
            className: classnames("perxis-auto-dealer-info-schedule__email"),
            children: email
          },
          i
        )) })
      )
    ] }) });
  };
  const renderSchedulesCell = (item) => {
    var _a;
    if (!((_a = item.schedules) == null ? void 0 : _a.length)) {
      return /* @__PURE__ */ jsx("td", {});
    }
    return renderCell(
      { item, type: "schedules" },
      /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-schedule__container"), children: item.schedules.map((schedule, i) => /* @__PURE__ */ jsx(
        Typography.Text,
        {
          level: "small",
          color: "dark",
          className: classnames("perxis-auto-dealer-info-schedule__timetable"),
          children: schedule
        },
        i
      )) }) })
    );
  };
  return /* @__PURE__ */ jsx(
    "table",
    {
      className: classnames(
        [
          "perxis-auto-dealer-info-schedule",
          {
            "perxis-auto-dealer-info-schedule--rtl": isRTL,
            "perxis-auto-dealer-info-schedule--multi": items.length > 1
          }
        ],
        className
      ),
      children: /* @__PURE__ */ jsx("tbody", { children: pairItems.map(([firstItem, secondItem]) => {
        var _a, _b;
        const firstItemContacts = [...(firstItem == null ? void 0 : firstItem.phones) || [], ...(firstItem == null ? void 0 : firstItem.emails) || []];
        const secondItemContacts = [...(secondItem == null ? void 0 : secondItem.phones) || [], ...(secondItem == null ? void 0 : secondItem.emails) || []];
        const isShowContactsRow = !!firstItemContacts || !!secondItemContacts;
        const isShowSchedulesRow = !!((_a = firstItem.schedules) == null ? void 0 : _a.length) || !!((_b = secondItem == null ? void 0 : secondItem.schedules) == null ? void 0 : _b.length);
        return /* @__PURE__ */ jsxs(React__default.Fragment, { children: [
          /* @__PURE__ */ jsxs("tr", { children: [
            (firstItem == null ? void 0 : firstItem.label) ? renderCell(
              { item: firstItem, type: "label" },
              /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsxs(
                Typography.Text,
                {
                  color: "dark-light",
                  level: "small",
                  className: classnames("perxis-auto-dealer-info-schedule__label"),
                  children: [
                    firstItem.label,
                    ":"
                  ]
                }
              ) })
            ) : /* @__PURE__ */ jsx("th", {}),
            (secondItem == null ? void 0 : secondItem.label) ? renderCell(
              { item: secondItem, type: "label" },
              /* @__PURE__ */ jsx("th", { children: /* @__PURE__ */ jsxs(
                Typography.Text,
                {
                  color: "dark-light",
                  level: "small",
                  className: classnames("perxis-auto-dealer-info-schedule__label"),
                  children: [
                    secondItem.label,
                    ":"
                  ]
                }
              ) })
            ) : /* @__PURE__ */ jsx("th", {})
          ] }),
          isShowContactsRow && /* @__PURE__ */ jsxs("tr", { children: [
            renderContactsCell(firstItem),
            !!secondItem && renderContactsCell(secondItem)
          ] }),
          isShowSchedulesRow && /* @__PURE__ */ jsxs("tr", { children: [
            renderSchedulesCell(firstItem),
            !!secondItem && renderSchedulesCell(secondItem)
          ] })
        ] }, firstItem.id);
      }) })
    }
  );
};
export {
  DealerInfoSchedule as default
};
//# sourceMappingURL=DealerInfoSchedule.js.map
